import { AirlineSeatIndividualSuiteSharp, SettingsRemote } from '@material-ui/icons';
import React, { useState, useEffect} from 'react';
import './dnd.css';
import VariablePicker from './VariablePicker';

import ViewIcon from '@material-ui/icons/Visibility';

import { LightTooltip } from './LightTooltip';
import IconButton from "@material-ui/core/IconButton";
import Dialog from './Dialog';

export default (props) => {

  var name = null
  var type = null
 
 
  const [showSubTaskPicker, setShowSubTaskPicker] = useState(false)

  const [subtasks, setSubTasks] = useState([])

  const [pickItem, setPickItem] = useState([])

  const renderSubTasks = ()=>{
        
    return subtasks.map(subtask => {
        return (
        <option value={subtask}>{subtask}</option>
        )

    });
    
  }


  const setValues = ()=>{
    if (props.element == null || props.element.data == null || props.element.data.attributes == null) return

    var properties = props.element.data.attributes
    // var keys = Object.keys (properties)
    console.log(properties)

    for (var key in properties) {
      console.log(key)
      console.log(properties[key])
      if (key.startsWith("py/object")) continue     
      // document.getElementById(key).setAttribute("value", properties[key])
      var newKey = key
      if (key.startsWith('check') ) {
        newKey=key.slice(5)
        if ( properties[key] == 'true')
          document.getElementById(newKey).setAttribute("checked", "true")
        else 
          document.getElementById(newKey).removeAttribute("checked")
      }
      else
      if (key.startsWith("events")) continue     
      else
      document.getElementById(newKey).value = properties[key]
    }
  }

  useEffect(() => { 
    setValues() 

  });


  const onInputchange = (event) => {
    event.preventDefault()
    var properties = props.element.data.attributes 
    properties[event.target.name] = event.target.value
    console.log("inout changed" + event.target.name + ' and '  + event.target.value)

    console.log(properties)
    // update the main model to reflect changes in properties
    props.updateProperties(properties)
    event.target.setAttribute(event.target.name, event.target.value)
  }  

  const onCheckInputChange = (event) => {
    const { name, checked } = event.target;
    const { element, updateProperties } = props;
    const checkName = 'check' + name

    var properties = props.element.data.attributes 

    // Update the property corresponding to the checkbox.
    const value = checked ? 'true' : 'false';
    
    properties[checkName] = value ;

    console.log("Input changed " + checkName + " and " + checked);
    console.log(properties);

    // Update the main model to reflect changes in properties
    updateProperties(properties);
  }

  const tabIt = ()=>{
    console.log("tabIt called")
    props.addTab(props.element.data.label, props.element.data.label )
  }


  const renderLabel = (item)=>{

    console.log(item.name)
    console.log(item.name.startsWith('check'))
    if (item.name.startsWith ("events")){
    return      
     
    }
    else if (item.name.startsWith('check')){

      return  <label style={{fontWeight:'bold' , fontSize:'12px'}}>{item.name.slice(5).toUpperCase()}</label>     

    }

    else
    return  <label style={{fontWeight:'bold', fontSize:'12px'}}>{item.name.toUpperCase()}</label>     

  
  }

 const selectTask = () =>{

 } 

 const openTask = () =>{  

} 

const showSubTasksPicker = ()=> {
  const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'}
    }

    var endPoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/subtasks/list/' + props.getObjectType().toLowerCase() + '/' + props.getEntityName() + '/' 
    if (props.getObjectType() == "SUBTASK")
      endPoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/subtasks/list/' + props.getParentObjectType().toLowerCase() + '/' + props.getParentEntityName() + '/'

    fetch(endPoint, requestOptions)
    .then (async response => {
      const data = await response.json();
      if (!response.ok) 
      {
        const error = (data && data.message) || response.status;
        console.log(error)
        return Promise.reject(error);

      }
      console.log(data)  
      setSubTasks(data)
      setShowSubTaskPicker(true)
    })

    .catch(error => {alert(        alert("Please ensure that your local agent is running")
    )});
}



const renderPickList = (item) =>{
  if (item.name.toLowerCase().includes('subtaskname')){
    return (
      <LightTooltip title="Pick SubTask">
      <IconButton onClick={()=>showSubTasksPicker()}>
        <ViewIcon style={{color:'#feb200'}} fontSize="20px" />
      </IconButton>
    </LightTooltip>
  )
  }
  if (item.name.toLowerCase().includes('taskname')){
    return (
      <LightTooltip title="Pick Task">
      <IconButton onClick={()=>props.showTasksModal()}>
        <ViewIcon style={{color:'#feb200'}} fontSize="20px" />
      </IconButton>
    </LightTooltip>
  )
      
  }
  if (item.name.toLowerCase().includes('botname')){
    return (
      <LightTooltip title="Pick Bot">
      <IconButton onClick={()=>props.showModal()}>
        <ViewIcon style={{color:'#feb200'}} fontSize="20px" />
      </IconButton>
    </LightTooltip>
  )
      
  }

}


const onSubTaskPicked = () => {
  const subtaskname = document.getElementById('subtaskinp').value
  document.getElementById(pickItem.name).setInnerText(subtaskname)
  setShowSubTaskPicker(false)

}



const renderInput = (item)=>{
  
  if (item.name.startsWith ("events")){
  const action = item.name.substring(6)
  return (
  <div className='row'>
    {/* <button className="editbutton" id = {item.name} onClick={tabIt} type = "button">{"View " + action + " Actions..."}</button>      */}
    {/* <button className="editbutton" id = {item.name} onClick={selectTask} type = "button">{"Link " + action + " Task..."}</button>      */}
    {/* <button className="editbutton" id = {item.name} onClick={openTask} type = "button">{"Open " + action + " Task..."}</button>      */}
  </div>
  )
  }
  else
  if (item.name.startsWith ("check")){
    return <div className="checkbutton" style={{marginLeft: "60px", width:'20px'}}> <input type='checkbox' onChange={onCheckInputChange} name = {item.name.slice(5)} id = {item.name.slice(5)} ></input>     </div>
  
  }
  else 
  if (item.name == 'comment'){
    return (
      <textarea className='editvalue' name= {item.name}  id = {item.name} rows="10" cols="50"  onChange={onInputchange}></textarea>
      )
    
  }
  else
  if (item.name == 'doc'){
    return (
      <textarea disabled value = {item.value} className='editvalue' name= {item.name}  id = {item.name} rows="3" cols="50"  ></textarea>
      )
    
  }

  return (
    <input className='editvalue' name= {item.name}  id = {item.name} type = "text"  onChange={onInputchange}></input>
  )
}  


const renderIcon = (item)=>{

  var properties = props.element.data.attributes
  if (properties[item.name] == "" || properties[item.name] == null)
    return

  // if (item.name.startsWith ('taskName')){
    if (item.name.toLowerCase().includes('subtaskname')){
      return (
            <LightTooltip title="View Sub Task">
              <IconButton onClick={()=>props.viewSubTask(properties[item.name])}>
                <ViewIcon style={{color:'#feb200', bottomPadding:'20px'}} fontSize="20px" />
              </IconButton>
            </LightTooltip>
    
      
    
      )
      }
    

  if (item.name.toLowerCase().includes('taskname')){
  return (
        <LightTooltip title="View Task">
          <IconButton onClick={()=>props.viewTask(properties[item.name])}>
            <ViewIcon style={{color:'#feb200', bottomPadding:'20px'}} fontSize="20px" />
          </IconButton>
        </LightTooltip>

  

  )
  }

  
  if (item.name.startsWith ('botName')){
    return (
          <LightTooltip title="View Bot">
            <IconButton onClick={()=>props.viewBot(properties[item.name])}>
              <ViewIcon style={{color:'#feb200', bottomPadding:'20px'}} fontSize="20px" />
            </IconButton>
          </LightTooltip>
  
    
  
    )
    }
  

}


const renderProperties = ()=>{


  if (props.element == null)
  return
  if ( props.element.data ==null)
  return 

  var properties = props.element.data.attributes
  if (properties == undefined) return
  // Adding the disable property for each action 
  // if (properties['checkDisable'] == null || properties['checkDisable'] == undefined) 
  // {  properties['checkDisable'] = 'false' }
  
  // Adding comment field
  if (properties['comment'] == null || properties['comment'] == undefined) 
  {  properties['comment'] = "" }
  
  var attributesArray = []
  for (var i in properties)
  { 
    if ( i == 'py/object' )
    continue
    var temp = {}
    temp.name = i
    temp.value=properties[i]
    attributesArray.push(temp)
    console.log(temp)

  }


  return attributesArray.map(item=>{

    return <div className='formtext'>
    <div class="col" >
    {renderLabel(item)}
    {/* task view  or Bot view icon */}
    {renderIcon(item)}    

    </div>



    <div class="row" >

    {renderInput(item)}

        
    </div>


    <br></br>
    </div>
  });
}

  if (props.element == null || props.element.data ==null)
  name = '' 
  else
  name = props.element.data.label

  // const renderHead = (name)=>{
  //   if (name != "")
  //   return(
  //    <>
  //     <h4>{name}</h4>
  //     <div className="row acheckbox">
  //     <input id='disableflag' type='checkbox'/>
  //     <label for="disableflag">Disable</label>
  //     </div>
  //     </>
  //   )

  // }


  return (
        <div className='attributes'>

        <h3 className='attributestitle'>Attributes</h3>
        <h4>{name}</h4>

        <div className="formtext">
          {  
             renderProperties()
          }
          <br></br>
        </div>
  
        <Dialog
              title={"Pick Sub Task"}
              message={"Pick your sub-task from the list below"}
              handleLoad={onSubTaskPicked}
              
              open={showSubTaskPicker}
              setOpen={setShowSubTaskPicker}
              render={renderSubTasks}
              inp='subtaskinp'
            ></Dialog>



        </div>
        
      

      );
};